export class LimegearUserModel {
    public username: string;
    public firstAndLastName: string;
    public token: string;
    public refreshToken: string;
    public decoded: any;
    public clientShortName: string;
    public clientCustomRoleName: string;
    public isSuperUser: boolean;
    public isPlatformUser: boolean;
    public isDemoUser: boolean;
    public isClientPowerUser: boolean;
    public timeZoneGMTVariance: number;
    public userGUID: string;
    public isDSTObserved: boolean;
    public impersonation?: LimegearUserImpersonationModel;
    public userAccessLevel: number;
    public clientCustomroleAccessName: string;
    public isClientOwner: boolean;
    public hasGLAccess: boolean;
    public accountID?: string;
    public clientFullName: string;
    public baseClient?: boolean;
}

export class LimegearUserImpersonationModel {
    public loginEmail?: string;
    public clientShortName?: string;
}
